export default __webpack_public_path__ + "static/media/SeaLife_22.33f8210b.png";